import { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux";
import { cleanUnderReviewAction } from "./QueueSlice";

export const useMeasure = () => {
  const elementHeight: any = (procentage: number) => {
    const height = window.screen.height;
    return height * procentage;
  };
  const elementWidth: any = (procentage: number) => {
    const width = window.screen.width;
    return width * procentage;
  };

  return { elementHeight, elementWidth };
};

export const useActivity = (min: number) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(60);
  const dispatch = useAppDispatch();
  useEffect(() => {
    let activityTimeout: NodeJS.Timeout;
    let countdownInterval: NodeJS.Timeout;

    const handleActivity = () => {
      clearTimeout(activityTimeout);
      clearInterval(countdownInterval);
      setCountdown(60);
      setIsModalOpen(false);
      activityTimeout = setTimeout(() => {
        setIsModalOpen(true);
        countdownInterval = setInterval(() => {
          setCountdown((prevCountdown) => {
            if (prevCountdown <= 1) {
              clearInterval(countdownInterval);
              restartQueue();
            }
            return prevCountdown - 1;
          });
        }, 1000);
      }, (min - 1) * 60 * 1000);
    };
    document.addEventListener("mousemove", handleActivity);
    handleActivity();
    return () => {
      document.removeEventListener("mousemove", handleActivity);
      clearTimeout(activityTimeout);
      clearInterval(countdownInterval);
    };
  }, []);

  const handleStaySignedIn = () => {
    setIsModalOpen(false);
    setCountdown(60);
  };

  const restartQueue = async () => {
    await dispatch(cleanUnderReviewAction());
  };

  return { isModalOpen, countdown, handleStaySignedIn, restartQueue };
};
